import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CALL_STATUS } from "./constants";
import profileAPI from "../../api/profile";

const initialState = {
	status: CALL_STATUS.IDLE,
	deleteStatus: CALL_STATUS.IDLE,
	error: null,
	data: []
}

export const getProfile = createAsyncThunk('accounts/GET_PROFILE', async (token) => {
	const response = await profileAPI.getProfile(token);
	return response;
}
);

export const deleteProfile = createAsyncThunk('accounts/DELETE_PROFILE', async (token, { rejectWithValue }) => {
	try {
		const response = await profileAPI.deleteProfile(token);
		return response;
	} catch (error) {
		return rejectWithValue(error.message);
	}
});

const profileSlice = createSlice({
	name: "profile",
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(getProfile.pending, (state, action) => {
				state.status = CALL_STATUS.PENDING;
				state.error = null;
			})
			.addCase(getProfile.fulfilled, (state, action) => {
				state.status = CALL_STATUS.SUCCESS;
				state.error = null;
				state.data = action.payload.data;
			})
			.addCase(getProfile.rejected, (state, action) => {
				state.status = CALL_STATUS.ERROR;
				state.error = null;
			})
			.addCase(deleteProfile.pending, (state) => {
				state.deleteStatus = CALL_STATUS.PENDING;
				state.error = null;
			})
			.addCase(deleteProfile.fulfilled, (state) => {
				state.deleteStatus = CALL_STATUS.SUCCESS;
				state.data = [];
			})
			.addCase(deleteProfile.rejected, (state, action) => {
				state.deleteStatus = CALL_STATUS.ERROR;
				state.error = action.payload;
			});
	}
});

const { actions, reducer } = profileSlice;

export const {
	reset
} = actions;

export default reducer;